import { Component } from '@angular/core';
import { HvtSection6Dto } from '../../../models/notices/ojeu.notice.models';
import { FormType } from '../../../models/notices/ojeu.notice.enums';
import { HvtSectionBase } from './hvt.section.base';
import {HvtSection6ContactDto} from '../../../models/notices/ojeu.notice.models';

@Component({
    selector: 'hvt-s6',
    template: require('./hvt.section.6.component.html')
})
export class HvtS6Component extends HvtSectionBase<HvtSection6Dto> {
    hvtS6: HvtSection6Dto;
    isContractAward: boolean;

    populate(hvtS6: HvtSection6Dto, formType: FormType, isContractAward: boolean = false) {
        this.hvtS6 = hvtS6;
        this.formType = formType;
        this.isContractAward = isContractAward;
    }

    clear() {
        this.hvtS6 = null;
        this.formType = null;
    }

    showSectionVI1() {
        return this.formType !== FormType.F012014 &&
            this.formType !== FormType.F032014 &&
            this.formType !== FormType.F042014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F212014 &&
            this.formType !== FormType.F062014 &&
            this.formType !== FormType.F232014; // 333131
    }

    showSectionVI2() {
        if (this.formType === FormType.F212014 && this.isContractAward) {
            return false; //323522
            //F21 tenders should show this section: 359041, 359064
        }

        return this.formType !== FormType.F032014 &&
            this.formType !== FormType.F152014 &&
            this.formType !== FormType.F062014 &&
            (this.hvtS6.electronicWorkflow.eOrdering ||
                this.hvtS6.electronicWorkflow.eInvoicing ||
                this.hvtS6.electronicWorkflow.ePayment ||
            (this.hvtS6.mediationBodyAddress && this.addressHasValue(this.hvtS6.mediationBodyAddress)) ||
            (this.hvtS6.reviewInfoAddress && this.addressHasValue(this.hvtS6.reviewInfoAddress)) ||
            (this.hvtS6.reviewBodyAddress && this.addressHasValue(this.hvtS6.reviewBodyAddress)) ||
                this.hvtS6.reviewProcedure);
    }

    showSectionVI4() {
        return (this.hvtS6.reviewBodyAddress && this.addressHasValue(this.hvtS6.reviewBodyAddress)) ||
            (this.hvtS6.mediationBodyAddress && this.addressHasValue(this.hvtS6.mediationBodyAddress)) ||
            (this.hvtS6.reviewInfoAddress && this.addressHasValue(this.hvtS6.reviewInfoAddress)) ||
            this.hvtS6.reviewProcedure;
    }

    showSectionVI5() {
        return this.hvtS6.jsNoticeDispatchDate;
    }

    addressHasValue(address: HvtSection6ContactDto) {
        return address.phone ||
            address.officialName ||
            address.nutsCode ||
            address.email ||
            address.fax ||
            address.generalUrl ||
            address.nationalId ||
            (address.address &&
            (address.address.line1 ||
                address.address.town ||
                address.address.country ||
                address.address.postcode));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.6.component.ts